<script setup lang="ts">
import { default as ButtonEl } from '@/components/shared/Button.vue';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import { IProfile } from '@/interfaces';

const emit = defineEmits(['close', 'success']);

interface Props {
  newProfile: IProfile;
  oldProfile: IProfile;
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <BaseOverlay
    @close="emit('close')"
    :title="$t('scheduleShift.replaceWith') + newProfile.displayName + '?'"
  >
    <template #content>
      <div class="flex justify-center items-center py-24">
        <div class="profile flex flex-col items-center opacity-60">
          <img
            class="profileImage rounded-full shadow-lg object-cover border-8 border-white mb-4 h-60 w-60"
            v-optimized="{
              src: oldProfile.displayImage,
            }"
          />
          <p class="text-2xl font-bold text-center">
            {{ oldProfile.displayName }}
          </p>
        </div>
        <div class="profile flex flex-col items-center -ml-12 z-10">
          <img
            class="profileImage rounded-full shadow-lg object-cover border-8 border-white mb-4 h-60 w-60"
            :src="newProfile.displayImage"
            v-optimized="{ src: newProfile.displayImage }"
          />
          <p class="text-2xl font-bold text-center">
            {{ newProfile.displayName }}
          </p>
        </div>
      </div>
      <div class="flex justify-center gap-3">
        <ButtonEl
          text="scheduleShift.replace"
          :icon="['fal', 'fa-exchange']"
          :shadow="true"
          class="self-center"
          background="bg-green-400"
          @click="emit('success')"
        />
        <ButtonEl
          text="global.cancel"
          :icon="['fal', 'fa-undo']"
          :shadow="true"
          class="self-center"
          background="bg-neutral-0"
          textColor="text-neutral-1000"
          @click="emit('close')"
        />
      </div> </template
  ></BaseOverlay>
</template>
